module.exports = require("core-js/library/fn/symbol/iterator");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/core-js/symbol/iterator.js
// module id = ./node_modules/@babel/runtime/core-js/symbol/iterator.js
// module chunks = 0